import { TextField, InputAdornment, styled, Box, Button } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'
import { useEffect, useState, MouseEvent } from 'react'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { SPACING } from '@common/theme/spacing'
import { SIZING } from '@common/theme/sizing'
import AddUserMenu from './AddUserMenu'

export interface Props {
  onSearch?: (value: string) => void
  onAddUser?: () => void
  searchValue?: string
  onUserTypeSelect: (userType: string) => void
}

const ToolbarContainer = styled(Box)({
  padding: 16,
  justifyContent: 'flex-end',
  gap: 16,
  alignItems: 'center',
  textAlign: 'right',
})

export default function UserManagementTableToolbar({ onSearch, searchValue, onUserTypeSelect }: Readonly<Props>) {
  const [localSearchValue, setLocalSearchValue] = useState(searchValue ?? '')
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLocalSearchValue(event.target.value)
  }

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && onSearch) {
      onSearch(localSearchValue)
    }
  }

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleUserTypeSelect = (userType: string) => {
    onUserTypeSelect(userType)
  }

  useEffect(() => {
    setLocalSearchValue(searchValue ?? '')
  }, [searchValue])

  return (
    <ToolbarContainer>
      <Button
        variant="contained"
        color="secondary"
        endIcon={<ExpandMoreIcon />}
        size="small"
        sx={{ mr: SPACING.spacingLg, mt: SPACING.spacingSm }}
        onClick={handleClick}
      >
        Add user
      </Button>
      <AddUserMenu anchorEl={anchorEl} onClose={handleClose} onUserTypeSelect={handleUserTypeSelect} />
      <TextField
        placeholder="Search"
        variant="outlined"
        size="small"
        sx={{ minWidth: SIZING.textFieldWidth, marginLeft: 'auto' }}
        value={localSearchValue}
        onChange={handleSearchChange}
        onKeyDown={handleKeyDown}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </ToolbarContainer>
  )
}
